var _defs, _path, _path2, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSekeBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 635.3 533.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f5bd18;\n      }\n\n      .cls-2 {\n        fill: #b4d569;\n      }\n\n      .cls-3 {\n        fill: #27b173;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M178.18,533.55C79.93,533.55,0,453.62,0,355.37S79.93,177.18,178.18,177.18s178.18,79.93,178.18,178.18-79.93,178.18-178.18,178.18Zm0-355.37C80.48,178.18,1,257.67,1,355.37s79.48,177.18,177.18,177.18,177.18-79.48,177.18-177.18-79.48-177.18-177.18-177.18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M455.11,447.22c-99.35,0-180.18-80.83-180.18-180.18s80.83-180.18,180.18-180.18,180.18,80.83,180.18,180.18-80.83,180.18-180.18,180.18Zm0-355.37c-96.6,0-175.18,78.59-175.18,175.18s78.59,175.18,175.18,175.18,175.18-78.59,175.18-175.18-78.59-175.18-175.18-175.18Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 365.76,
    cy: 177.68,
    r: 177.68
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSekeBg);
export default __webpack_public_path__ + "static/media/seke-bg.674caf4b22fc64ff1eff567af6868336.svg";
export { ForwardRef as ReactComponent };